import FilterInput from 'components/styled/FilterInput'
import * as React from 'react'
import ResultSelect from 'components/styled/ResultSelect'
import { FilterLiveStyled } from 'components/styled/FilterLiveStyled'

const CheckoutsFilters = [
  <FilterLiveStyled key="context.customer.msisdn" label="MSISDN" source="context.customer.msisdn" />,
  <FilterLiveStyled key="context.customer.document" label="Document" source="context.customer.document" />,
  <FilterLiveStyled key="context.customer.customer_id" label="Customer Id" source="context.customer.customer_id" />,
  <FilterLiveStyled key="context.reference_id" label="Reference Id" source="context.reference_id" />,
  <ResultSelect key="result" label="Result" source="result" />,
  <FilterInput key="id" label="Id" source="id" />
]

export default CheckoutsFilters
